module.exports = __webpack_public_path__ + "media/images/metromanila-fe90b84355cac378d25faa5e49d42774.png";